import { ExperimentName } from 'modules/experiments/components/ui';
import {
  getTakeoverCampaignMessageMedium,
  getTakeoverExperimentId,
  getTakeoverExperimentName,
  getTakeoverExperimentType,
} from 'modules/experiments/ducks/selectors';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { useSelector } from 'react-redux';
import { ErrorAccordion } from './ErrorAccordion';
import { ExperimentLocaleSwitcher } from './ExperimentLocaleSwitcher';
import { ExperimentTypeSubHeader } from './ExperimentTypeSubHeader';
import {
  ErrorAccordionWrapper,
  HeaderContainer,
  HeaderTitleSection,
  HeaderToolbarSection,
  NameWrapper,
} from './Styled';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';

export const PageHeader = () => {
  const { t } = useExperimentsTranslations();
  const experimentName = useSelector(getTakeoverExperimentName);
  const experimentId = useSelector(getTakeoverExperimentId);
  const experimentType = useSelector(getTakeoverExperimentType);
  const messageMedium = useSelector(getTakeoverCampaignMessageMedium);
  const { hasLocales } = useLocaleSettingsContext();
  const experimentTypeDisplay = t(`experimentType.${experimentType}`);
  const experimentTypeTDisplay = t('takeover.title', {
    experimentType: experimentTypeDisplay,
  });

  if (!experimentName) return null;
  return (
    <HeaderContainer>
      <HeaderTitleSection>
        <NameWrapper>
          <ExperimentName name={experimentName} id={experimentId} messageMedium={messageMedium} />
        </NameWrapper>
        <ExperimentTypeSubHeader text={experimentTypeTDisplay} />
      </HeaderTitleSection>
      <HeaderToolbarSection>
        <div>
          <ErrorAccordionWrapper>
            <ErrorAccordion />
          </ErrorAccordionWrapper>
        </div>
        {hasLocales && <ExperimentLocaleSwitcher />}
      </HeaderToolbarSection>
    </HeaderContainer>
  );
};
